<template>
    <div class="white-board-box" :class="{ 'white-board-box-full': fullsrceen }" @click="whiteboardTap" :style="LandscapeStyle">
        <template v-if="direct_status == 'running'">
            <div id="white-board" :style="{ height: Landscape ? '100%' : '56vw' }"></div>
            <div class="white-board-bottom" v-show="isShowBoardBottom">
                <img v-if="fullsrceen" @click="LandscapeTap" class="fullsrceenBtn" style="margin-right: 10px;"
                    src="../../../statics/imgs/home/rotate.png">
                <template v-if="!Landscape">
                    <img v-if="fullsrceen" @click="fullScreenTap" class="fullsrceenBtn"
                        src="../../../statics/imgs/home/exitFullscreen.png">
                    <img v-else @click="fullScreenTap" class="fullsrceenBtn"
                        src="../../../statics/imgs/home/whiteboardfullsicon.png">
                </template>
            </div>
            <!-- 切换 -->
            <img v-show="!fullsrceen" @click="changeScreenPostionTap" class="positionIcon"
                src="../../../statics/imgs/home/switchIcon.png">
            <!-- 刷新 -->
            <!-- <img v-show="!fullsrceen" class="refreshIcon" @click="refreshTap" src="../../../statics/imgs/home/refresh1.png"> -->
        </template>
        <p class="noDataTip" v-else>
            <img style="width: 160px;" src="https://tengfaceliveuser.tengface.net/web/wx-user/img/wbnothing.png">
            <span style="color: #ccc;font-size: 14px;margin: 10px 7px 0 0;">暂无内容</span>
        </p>
    </div>
</template>
<script>
import tool from "../../kits/Tools"
import TIM from 'tim-js-sdk'
export default {
    props: ['ds_id', 'fans_id', 'direct_status','im_type'],
    data() {
        return {
            teduBoard: null,
            fullsrceen: false,
            Landscape: false,
            LandscapeStyle: {},
            isShowBoardBottom:true
        }
    },
    computed: {
        userInfo() {
            return {
                ds_id: this.ds_id,
                fans_id: this.fans_id,
                direct_status: this.direct_status
            }
        }
    },
    watch: {
        userInfo(newVla, oldVal) {
            if (newVla.ds_id && newVla.fans_id) {
                this.$nextTick(() => {
                    this.createwhiteboard()
                })
            }
        }
    },
    mounted() {
        if (this.userInfo.ds_id && this.userInfo.fans_id) {
            this.createwhiteboard()

        }
    },
    methods: {
        whiteboardTap(){
            
        },
        exitFullScreen(){
            if (this.fullsrceen) { //退出全屏
                this.Landscape  = false
                this.fullsrceen = false
                this.LandscapeStyle = {}
            }
        },
        refreshTap(){
           if (this.teduBoard) {
             this.teduBoard.refresh()
           }
        },
        addMessageSyncData(data){ //添加画板消息
           if (this.teduBoard) {
            this.teduBoard.addSyncData(data);
           }
        },
        async createwhiteboard() {
            console.log("createwhiteboard---im_type",this.im_type)
            if (!this.teduBoard && this.direct_status == 'running') {
                try {
                    let params = "uid=" + this.fans_id + "&ds_id=" + this.ds_id
                    let res = await this.axios.post(tool.baseUrl1() + "/api/whiteboard/getThreeUserSig", params)
                    if (res && res.data && res.data.code == 200) {
                        console.log("res=====data", res.data.data)
                        var initParams = {
                            id: 'white-board',
                            classId: this.ds_id,
                            sdkAppId: res.data.data.appid,
                            userId: res.data.data.uid,
                            userSig: res.data.data.tl_sign,
                            authConfig: {
                                drawEnable: false
                            },
                            config:{
                                ratio:'16:9'
                            }
                        };
                        this.teduBoard = new TEduBoard(initParams);
                        if (this.im_type == 2) {
                           this.loginWhiteBoardIM({sdkAppId: res.data.data.appid, userSig: res.data.data.tl_sign}) 
                        }
                    }
                } catch (error) {

                }
            }
        },
        loginWhiteBoardIM (loginInfo) {
            let that = this;
            let tim = TIM.create({SDKAppID: parseInt(loginInfo.sdkAppId)})
            // 监听消息事件
            tim.on(TIM.EVENT.MESSAGE_RECEIVED, (event) => {
                // 收到推送的单聊、群聊、群提示、群系统通知的新消息，可通过遍历 event.data 获取消息列表数据并渲染到页面
                for (let index = 0; index < event.data.length; index++) {
                    const element = event.data[index]
                    if (element.conversationType === TIM.TYPES.CONV_GROUP && this.ds_id == element.to) { // 群消息
                        if (element.type === 'TIMCustomElem') {
                            if (element.payload.extension === 'TXWhiteBoardExt') {
                                this.addMessageSyncData(element.payload.data)
                            }
                        }
                    }
                }
            })
            // 登录IM
            tim.login({userID: `${this.fans_id}`, userSig: loginInfo.userSig}).then((imResponse)=> {
                console.log('开始登录', imResponse.data)
                tim.joinGroup({ groupID:`${this.ds_id}`, type: TIM.TYPES.GRP_AVCHATROOM }).then((imResponse) => {
                console.log('开始登录', imResponse)
                })
            }).catch(function (imError) {
                that.$emit('errorReport', {msg: '白板加入群聊错误', error: imError})
                console.warn('login error:', imError) // 登录失败的相关信息
            })
        },
        fullScreenTap() {
            this.fullsrceen = !this.fullsrceen
            // this.$nextTick(()=>{
                // this.teduBoard.resize()
            // })
        },
        changeScreenPostionTap() {
            this.$emit("changPosion")
        },
        LandscapeTap() {
            this.Landscape = !this.Landscape;
            if (this.Landscape) {
                var conW = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                var conH = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
                // transform: rotate(90deg); width: 667px; height: 375px;transform-origin:28% 50%;
                this.LandscapeStyle = {
                    transform: "rotate(90deg) translate(" + ((conH - conW) / 2) + "px," + ((conH - conW) / 2) + "px)",
                    height: "100vw",
                    width: "100vh",
                    'transform-origin': "center center"
                }
            } else {
                this.fullsrceen = false
                this.LandscapeStyle = {}
            }
        }
    }
}
</script>
<style scoped>
.white-board-box {
    width: 100%;
    height: 100%;
    position: relative;
}

.white-board-box #white-board {
    width: 100%;
    height: 56vw;
}

.white-board-bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 40px;
    background: linear-gradient(rgba(255,255,255,0.2), rgba(0,0,0,0.2));
    /* box-shadow:0px -1px 1px black; */
    display: flex;
    justify-items: center;
    align-items: center;
    justify-content: flex-end;
    padding: 0 10px;
}

.fullsrceenBtn {
    width: 25px;
    height: 25px;
}

.positionIcon {
    position: absolute;
    left: 11px;
    width: 25px;
    height: 25px;
    top: 50%;
    z-index: 1;
    transform: translateY(-50%);
}
.refreshIcon{
    position: absolute;
    right: 11px;
    width: 25px;
    height: 25px;
    top: 50%;
    z-index: 1;
    transform: translateY(-50%); 
}

.white-board-box-full {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1900;
    background-color: black;
    display: flex;
    align-items: center;
}

.noDataTip{
    /* position: relative; */
    width: 100%;
    height: 100%;
    /* text-align: center; */
    /* vertical-align: middle; */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #1e1e1e;
}
</style>


// WEBPACK FOOTER //
// whiteboard.vue?592272bb